import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import RenderFormItem from 'components/CtxFormFields/FormFieldCtx';
import { Ctx } from 'components/CtxFormFields/CtxInputs';
import useErrorState, { translateError } from 'utils/hooks/useErrorState';
import { getMSDataByEntity } from 'rdx/hardware';
import { getCurrentOS } from 'utils';
import { getIntegrationConfig } from 'service/InstallerApp';

import { smartCardFields } from './formShape';

function ExtDevIdCard() {
  const [swedbankInfo, setSwedbankInfo] = useState({});
  const formContext = useContext(Ctx);
  const { integrationState, setEnabledSave } = formContext.values;
  const ms = useSelector(getMSDataByEntity('extdev-microservice'));
  const { msIsInstalled } = ms;
  const values = { ...integrationState };
  const isWindows = getCurrentOS() === 'Windows';
  const {
    entity: swedEntity,
    installedVersion: swedInstalledVersion,
    msIsInstalled: swedMsIsInstalled,
  } = useSelector(getMSDataByEntity('swedbank-ingenico'));

  useEffect(() => {
    if (swedEntity && swedInstalledVersion) {
      getIntegrationConfig(swedEntity, swedInstalledVersion).then(
        ({ data }) => {
          try {
            const config = JSON.parse(data.config);
            setSwedbankInfo(config);
          } catch (err) {
            console.error(err);
          }
        },
      );
    }
  }, [swedEntity, swedInstalledVersion, swedMsIsInstalled]);

  useEffect(() => {
    if (Object.keys(swedbankInfo).length) {
      if (values.SmartCardType === 'swedbank') {
        formContext.onChange({
          SmartCardHTTPDevicePort: String(swedbankInfo.Port),
        });
      }
    }
  }, [swedbankInfo]);

  const showForm = msIsInstalled;

  const data = useMemo(() => Object.values(smartCardFields), [smartCardFields]);
  const onChange = (key, value) => {
    if (key === 'SmartCardType') {
      if (value === 'usb')
        formContext.onChange({ SmartCardHTTPDevicePort: '' });
      if (value === 'swedbank' && swedbankInfo.Port)
        formContext.onChange({
          SmartCardHTTPDevicePort: String(swedbankInfo.Port),
        });
    }
    formContext.onChange({ [key]: value });
  };
  const validationObject = {
    ...smartCardFields,
  };

  const { errors, hasErrors } = useErrorState(
    integrationState,
    validationObject,
  );

  useEffect(() => {
    setEnabledSave(!hasErrors);
  }, [errors]);

  return (
    <Ctx.Provider
      value={useMemo(() => ({ values, onChange }), [values, onChange])}
    >
      {showForm ? (
        <Card className="flex-fill my-3">
          <Card.Header>Extdev ID Card Credentials</Card.Header>
          <Card.Body className="d-flex">
            <Form className="d-flex flex-column flex-fill">
              {data.map(({ validate, ...rest }) => (
                <RenderFormItem
                  disabled={rest.id === 'SmartCardHTTPDevicePort'}
                  key={rest.id}
                  size="md"
                  name={rest.id}
                  error={translateError(errors[rest.id])}
                  {...rest}
                />
              ))}
            </Form>
          </Card.Body>
        </Card>
      ) : (
        <h4>Please make sure that microservice is installed and running</h4>
      )}
      {showForm && isWindows && (
        <Card className="flex-fill my-3">
          <Card.Header>
            If the ID Card Reader works slowly in the POS. You can fix it by
            using the Local Group Policy Editor.
          </Card.Header>
          <Card.Body>
            <ol>
              <li>Launch gpedit.msc</li>
              <li>
                Section Computer Configuration {'-->'} Administrative Templates{' '}
                {'-->'}
                Windows Components {'-->'} Smart Card
              </li>
              <li>Turn on certificate propagation from smartcard: disable</li>
            </ol>
          </Card.Body>
        </Card>
      )}
    </Ctx.Provider>
  );
}

export default ExtDevIdCard;
